// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".EstimateQuickOrderDialog-body__hZ7Jd{display:flex;flex-direction:column;gap:var(--size-2);align-items:stretch;padding:var(--size-4)}.EstimateQuickOrderDialog-errorMessage__SzDnu{color:var(--tomato-11);font-weight:600}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": "EstimateQuickOrderDialog-body__hZ7Jd",
	"errorMessage": "EstimateQuickOrderDialog-errorMessage__SzDnu"
};
export default ___CSS_LOADER_EXPORT___;
